import React from 'react'
import InnerBanner from '../../../Components/InnerBanner/InnerBanner'
import { Col, Container, Row } from 'react-bootstrap'
import FaqIcon from '../../../assets/images/faq-icon.svg?react'
import ContactIcon from '../../../assets/images/contact-icon.svg?react'
import TermsOfUseIcon from '../../../assets/images/terms-of-use-icon.svg?react'
import PrivacyPolicyIcon from '../../../assets/images/privacy-policy-icon.svg?react'
import { Link } from 'react-router-dom'
import './index.css'

const HelpCenter = () => {
    return (
        <>
            <InnerBanner heading="Help Center" />
            <section className="py-sm-5 py-4">
                <Container>
                    <Row>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <Link to={'/contact-us'} className='d-block text-decoration-none'>
                                <div className="support-card">
                                    <h6>Contact Us</h6>
                                    <ContactIcon />
                                </div>
                            </Link>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <Link to={'/'} className='d-block text-decoration-none'>
                                <div className="support-card">
                                    <h6>FAQ</h6>
                                    <FaqIcon />
                                </div>
                            </Link>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <Link to={'/privacy-policy'} className='d-block text-decoration-none'>
                                <div className="support-card">
                                    <h6>Privacy Policy</h6>
                                    <PrivacyPolicyIcon />
                                </div>
                            </Link>
                        </Col>
                        <Col xs={12} sm={6} lg={3} md={4} className='my-3'>
                            <Link to={'/terms-and-conditions'} className='d-block text-decoration-none'>
                                <div className="support-card">
                                    <h6>Terms of Use</h6>
                                    <TermsOfUseIcon />
                                </div>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default HelpCenter
